export const LogoMark = ({ className = "h-12 w-12", src = "/logo-mark-sm.png" }) => (
  <img src={src} alt="Autocrat Rubber Industries logo" className={`object-contain ${className}`} draggable="false" />
);

export const Logo = ({ dark = true }) => (
  <span className="flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none">
      <img src="/logo-word.png" alt="Autocrat" className="block h-[21px] w-auto" draggable="false" />
      <span className={`font-mono-x mt-1.5 block text-[9.5px] uppercase tracking-[0.3em] ${dark ? "text-slate-300" : "text-slate-500"}`}>
        Rubber Industries
      </span>
    </span>
  </span>
);
